import { applyToText } from './text';
export function ellipsisIt(node, w, suffix) {
    if (suffix === void 0) { suffix = '...'; }
    applyToText(node, { wordWrap: true, wordWrapWidth: w, maxLines: 1, textOverflow: suffix });
}
//# sourceMappingURL=ellipsis.js.map